export const notificationsPath = {
  /* inject path */
  NOTIFICAIONS_SETTINGS: '/notifications/notificaions-settings',
};
